export default __webpack_public_path__ + "static/media/port-apvs.25725caf.webp";